import {Component, Injectable} from '@angular/core';

@Component({
    template: '<router-outlet></router-outlet>',
    styles: [require('../shared/section/section.component.scss'), require('./work-page.component.scss')]
})
@Injectable()
export class WorkPageComponent {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/work/work-page.component.ts